<template>
  <pt-counselor-table class="pt-counselor-table__withData" @getCounselorList="getCounselorList" :tableLabels="tableLabels" :page-size="page_size" :tableData="tableData"
  :totalNumber="totalNumber" ref="table" :loading="loading" :isOutside="isOutside">
    <slot/>
  </pt-counselor-table>
</template>

<script>
import PtCounselorTable from './index'
export default {
  name: 'pt-counselor-table__withData',
  props: {
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'pt-counselor-table': PtCounselorTable
  },
  data () {
    return {
      totalNumber: 0,
      page_size: this.pageSize,
      tableData: [],
      loading: false,
      isOutside: false
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
          // this.getCounselorList(0)
          this.$refs.table.resetPage()
        } else {
          this.isOutside = true
          this.getCounselorList(this.page)
        }
      }
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getCounselorList (page, next) {
      let data = {
        pageable: {
          page: page,
          size: this.page_size
        },
        position: this.paramsData.position ? this.paramsData.position : '',
        company: this.paramsData.company ? this.paramsData.company : '',
        searchKey: this.paramsData.searchKey ? this.paramsData.searchKey : ''
      }
      this.loading = true
      this.$store.dispatch('counselorFind', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err || '获取失败')
        this.$refs.table.showReTry()
        this.loading = false
      })
    },
    reload () {
      this.$refs.table.reload()
    }
  }
}
</script>
